<div class="home" *ngIf="data" [style.background-image]="backgroundImage">
    <div class="home-row-1" *ngIf="data.main_image">
        <div class="image">
            <img [src]="data.main_image" [alt]="data.main_image_alt">
        </div>
        <div class="date-line" [innerHTML]="data.date_line" *ngIf="data.date_line"></div>
        <!-- <div class="date-line"*ngIf="data.date_line">AUGUST 12<sup>ST</sup> - AUGUST 28<sup>TH</sup></div> -->
        <div class="description" [innerHTML]="data.description" *ngIf="data.description"></div>
    </div>
    <div class="home-row-2">
        <div class="title" [innerHTML]="data.title" *ngIf="data.title"></div>
        
        <div class="button">
            <button type="button" class="btn-gradient-home" (click)="startExploring()" [innerHTML]="data.button_title"></button>
        </div>
    </div>
    <div class="logos">
        <div class="col col-side col-1">
            <div class="logo" (click)="openUrl($event, 'https://www.futurearts.co/augmentseattle/')">
                <img src="../../../assets/images/future-arts-logo.png" alt="Future Arts Logo">
            </div>
        </div>
        <div class="col col-side col-3">
            <hi-powered-by></hi-powered-by>
        </div>
    </div>
</div>